// ============================================================
// HappyHouse — Images locales (toutes hébergées sur LWS)
// Ce fichier centralise TOUTES les références images du projet.
// Les fichiers .jpg sont dans public/images/ et buildés avec npm run build
// ============================================================

// --- Hero slides (page d'accueil) ---
export const IMG_HERO_1        = "/images/photo-1757924461488.jpg";  // appartement moderne
export const IMG_HERO_2        = "/images/photo-1757439402190.jpg";  // intérieur luxueux
export const IMG_HERO_3        = "/images/photo-1643913592251.jpg";  // chambre cosy

// --- Images de fallback pour les logements sans photo ---
export const IMG_FALLBACK_1    = "/images/photo-1758548157747.jpg";  // cuisine moderne
export const IMG_FALLBACK_2    = "/images/photo-1760067537740.jpg";  // chambre boutique
export const IMG_FALLBACK_3    = "/images/photo-1760067537116.jpg";  // chambre boutique 2

// --- Bannières / ambiances ---
export const IMG_COZY_LIVING   = "/images/photo-1773847400278.jpg";  // salon chaleureux
export const IMG_STONE_FIREPLACE = "/images/photo-1773847408152.jpg"; // cheminée pierre
export const IMG_FRENCH_VILLAGE = "/images/photo-1659027793165.jpg"; // village français
export const IMG_NARROW_STREET  = "/images/photo-1760372060494.jpg"; // rue étroite
export const IMG_WARM_LIVING    = "/images/photo-1770736158887.jpg"; // salon chaud

// --- Pages spécifiques ---
export const IMG_SIMULATEUR    = "/images/photo-1554224155.jpg";     // SimulateurPage
export const IMG_FAQ           = "/images/photo-1450101499163.jpg";  // FaqPage
export const IMG_SOUS_LOCATION = "/images/photo-1560448204.jpg";     // SousLocationPage
export const IMG_CONCIERGERIE  = "/images/photo-1522708323590.jpg";  // ConciergeriePage
export const IMG_VOYAGEURS     = "/images/photo-1600585154340.jpg";  // VoyageursPage
export const IMG_CONTACT       = "/images/photo-1760372060494.jpg";  // ContactPage
export const IMG_BLOG_HERO     = "/images/pexels-6782578.jpg";       // BlogPage hero
export const IMG_EXPERTISE_BANNER = "/images/photo-1773847408152.jpg"; // ExpertisePage banner
export const IMG_EXPERTISE_ABOUT  = "/images/photo-1743865319071.jpg"; // ExpertisePage about
export const IMG_LIMOGES       = "/images/photo-1669300568006.jpg";  // ville de Limoges
export const IMG_PROPRIETAIRES = "/images/pexels-7736029.jpg";       // ProprietairesPage

// --- Services (homeData) ---
export const IMG_SERVICE_REMISE_CLES   = "/images/pexels-7820321.jpg";
export const IMG_SERVICE_ETATS_LIEUX   = "/images/pexels-7614612.jpg";
export const IMG_SERVICE_MENAGE        = "/images/pexels-6466490.jpg";
export const IMG_SERVICE_LINGE         = "/images/pexels-4455836.jpg";
export const IMG_SERVICE_MAINTENANCE   = "/images/photo-1622936082250.jpg";
export const IMG_SERVICE_CONCIERGERIE  = "/images/pexels-7820689.jpg";
export const IMG_SERVICE_PHOTOS        = "/images/pexels-7414949.jpg";
export const IMG_SERVICE_TARIFICATION  = "/images/pexels-577210.jpg";

// --- Navigation (propriétés vedettes) ---
export const IMG_NAV_APPART    = "/images/photo-1600585154340.jpg";
export const IMG_NAV_MAISON    = "/images/photo-1560448204.jpg";
export const IMG_NAV_STUDIO    = "/images/photo-1522708323590.jpg";

// --- Articles / Blog guides ---
export const IMG_ARTICLE_1     = "/images/photo-1659027793165.jpg";
export const IMG_ARTICLE_2     = "/images/photo-1760372060494.jpg";
